<tn-icon name="information" library="mdi" customSize="1rem"></tn-icon>
<span class="message">
  {{ 'You are using an insecure connection. Switch to HTTPS for secure access.' | translate }}
</span>
